type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const ReceiptStatus = Object.freeze({
  COMPLETE: 1 as const,
  CANCEL: 2 as const,
});

export type ReceiptStatus = EnumLiteralsOf<typeof ReceiptStatus>;
